(function() {
    if (!document.body.classList.contains('woocommerce-checkout')) {
        return;
    }

    const STRIPE_LABEL_TEXT = 'Crédito à vista em Dólar';
    const STRIPE_SELECTOR = 'label[for="payment_method_stripe"]';

    function updateStripeLabel() {
        const stripeLabel = document.querySelector(STRIPE_SELECTOR);

        if (!stripeLabel) return;

        if (stripeLabel.textContent.trim() !== STRIPE_LABEL_TEXT) {
            stripeLabel.textContent = STRIPE_LABEL_TEXT;
        }
    }

    const observer = new MutationObserver(updateStripeLabel);

    document.addEventListener('DOMContentLoaded', function() {
        updateStripeLabel();

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        jQuery(document.body).on('updated_checkout', function() {
            updateStripeLabel();
        });
    });
})();